$(function () {
    $('#searchResultsButton').click(function (e) {
        e.preventDefault();
        processQuery(false);
    });

    $('#searchResultsMag').click(function (e) {
        e.preventDefault();
        processQuery(false);
    });

    $('#searchKeyword').keypress(function (e) {
        var key = e.which;
        if (key == 13)  // the enter key code
        {
            processQuery(false);
        }
    });
    $('#mobileSearchBtn').click(function (e) {
        e.preventDefault();
        processQuery(true);
    });
    $('#mobileSearchText').keypress(function (e) {
        var key = e.which;
        if (key == 13)  // the enter key code
        {
            processQuery(true);
        }
    });
});


function processQuery(isMobile) {
    var url = "/search";
    var keyword = "";
    if (isMobile) {
        keyword = $('#mobileSearchText').val();
    } else {
        keyword = $('#searchKeyword').val();
    }
    var queryString = "";
    if (keyword.length > 0) {
        queryString = "?q=" + keyword;
        url = url + queryString;
    }
    window.location.href = url;
}